"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getAspectsPairs = exports.houseAspects = exports.synastryTransitAspects = exports.prognosticsAspects = exports.synastryAspects = exports.natalAspects = exports.getAspectDiff = exports.checkAspect = void 0;
var defs_1 = require("./defs");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var astro_utils_1 = require("./astro-utils");
function checkAspect(orbise, lon1, lon2, aspType, opts) {
    var _a, _b, _c, _d, _e, _f;
    var signDiff = (0, utils_1.circularDistance)((0, astro_utils_1.getSign)(lon1), (0, astro_utils_1.getSign)(lon2), 12);
    var isRounded = (_a = opts === null || opts === void 0 ? void 0 : opts.isRounded) !== null && _a !== void 0 ? _a : true;
    if (isRounded && Number.isInteger(orbise)) {
        lon1 = Math.ceil(lon1);
        lon2 = Math.ceil(lon2);
    }
    if (!((_b = opts === null || opts === void 0 ? void 0 : opts.ignoreDiffSigns) !== null && _b !== void 0 ? _b : true) && constants_1.majorAspects.includes(aspType)) {
        var nom = aspType / 30;
        if (nom !== signDiff) {
            orbise *= (aspType === defs_1.AspectType.Conjunction ? (_c = opts === null || opts === void 0 ? void 0 : opts.overSign0) !== null && _c !== void 0 ? _c : 50 : (_d = opts === null || opts === void 0 ? void 0 : opts.overSign) !== null && _d !== void 0 ? _d : 70) / 100;
        }
    }
    orbise += (_e = opts === null || opts === void 0 ? void 0 : opts.floatingOrbise) !== null && _e !== void 0 ? _e : 0;
    orbise *= 1 + ((_f = opts === null || opts === void 0 ? void 0 : opts.orbiseCorrector) !== null && _f !== void 0 ? _f : 0) / 100;
    var lon = (0, utils_1.circularDistance)(lon1, lon2, 360);
    var diff = Math.abs(aspType - lon);
    return {
        lon: lon,
        diff: diff,
        orbise: orbise,
        exists: diff <= orbise
    };
}
exports.checkAspect = checkAspect;
function getAspectDiff(type, lon1, lon2, speed1, speed2) {
    var secsInDay = 24 * 3600.0;
    var asp1 = (0, utils_1.circularDistance)(lon1, lon2, 360);
    var asp2 = (0, utils_1.circularDistance)(lon1 + speed1 / secsInDay, lon2 + speed2 / secsInDay, 360);
    return Math.abs(type - asp2) - Math.abs(type - asp1);
}
exports.getAspectDiff = getAspectDiff;
function natalAspects(objects, opts, getPairOrbise, houses) {
    var aspects = [];
    var objectLength = houses ? objects.length + houses.length : objects.length;
    for (var obj1 = 0; obj1 < objects.length; obj1++) {
        if (obj1 === defs_1.ObjectType.Selena) {
            continue;
        }
        for (var obj2 = obj1 + 1; obj2 < objectLength; obj2++) {
            if (obj2 === defs_1.ObjectType.Selena) {
                continue;
            }
            var objInfo = houses && obj2 >= defs_1.ObjectType.House1
                ? {
                    lon: houses[obj2 - defs_1.ObjectType.House1],
                    speed: 0
                }
                : objects[obj2];
            var bestType = -1;
            var bestDiff = 360;
            var bestOrbise = 0;
            for (var _i = 0, allAspects_1 = constants_1.allAspects; _i < allAspects_1.length; _i++) {
                var aspType = allAspects_1[_i];
                var orb = getPairOrbise('natal', obj1, obj2, aspType);
                var asp = checkAspect(orb, objects[obj1].lon, objInfo.lon, aspType, opts);
                if (asp.exists &&
                    (constants_1.majorAspects.includes(aspType) === constants_1.majorAspects.includes(bestType)
                        ? asp.diff < bestDiff
                        : constants_1.majorAspects.includes(aspType))) {
                    bestDiff = asp.diff;
                    bestType = aspType;
                    bestOrbise = orb;
                }
            }
            if (bestType !== -1) {
                aspects.push({
                    id: aspects.length,
                    type: bestType,
                    obj1: obj1,
                    lon1: objects[obj1].lon,
                    obj2: obj2,
                    lon2: objInfo.lon,
                    orbise: bestOrbise,
                    realOrbise: bestDiff,
                    diff: getAspectDiff(bestType, objects[obj1].lon, objInfo.lon, objects[obj1].speed, objInfo.speed)
                });
            }
        }
    }
    var isCuspidAspect = function (asp) { return (asp.obj1 >= defs_1.ObjectType.House1 && asp.obj1 <= defs_1.ObjectType.House12) || (asp.obj2 >= defs_1.ObjectType.House1 && asp.obj2 <= defs_1.ObjectType.House12); };
    aspects = aspects.filter(function (asp) { var _a; return !isCuspidAspect(asp) || (isCuspidAspect(asp) && asp.realOrbise <= ((_a = opts === null || opts === void 0 ? void 0 : opts.maxCuspidOrbise) !== null && _a !== void 0 ? _a : 4)); });
    aspects = aspects.map(function (item, i) {
        item.id = i;
        return item;
    });
    return aspects;
}
exports.natalAspects = natalAspects;
function synastryAspects(objects, objectsExt, opts, getPairOrbise) {
    var aspects = [];
    for (var obj1 = 0; obj1 < objects.length; obj1++) {
        if (obj1 === defs_1.ObjectType.Selena) {
            continue;
        }
        for (var obj2 = 0; obj2 < objectsExt.length; obj2++) {
            if (obj2 === defs_1.ObjectType.Selena) {
                continue;
            }
            var bestType = -1;
            var bestDiff = 100;
            var bestOrbise = 0;
            for (var _i = 0, allAspects_2 = constants_1.allAspects; _i < allAspects_2.length; _i++) {
                var aspType = allAspects_2[_i];
                var orb = getPairOrbise('synastry', obj1, obj2, aspType);
                var asp = checkAspect(orb, objects[obj1].lon, objectsExt[obj2].lon, aspType, opts);
                if (asp.exists &&
                    asp.diff < bestDiff &&
                    (constants_1.majorAspects.includes(aspType) ||
                        !constants_1.majorAspects.includes(bestType))) {
                    bestDiff = asp.diff;
                    bestType = aspType;
                    bestOrbise = orb;
                }
            }
            if (bestType !== -1) {
                aspects.push({
                    id: aspects.length,
                    type: bestType,
                    obj1: obj1,
                    lon1: objects[obj1].lon,
                    obj2: obj2,
                    lon2: objectsExt[obj2].lon,
                    orbise: bestOrbise,
                    realOrbise: bestDiff
                });
            }
        }
    }
    return aspects;
}
exports.synastryAspects = synastryAspects;
function prognosticsAspects(mode, objects, houses, objectsExt, housesExt, opts, getPairOrbise, forDoubleMapWithOutNatal) {
    if (forDoubleMapWithOutNatal || mode === 'prog_prog') {
        objects = objectsExt;
        houses = housesExt;
    }
    var aspects = [];
    var objectLength = (houses.length) ? defs_1.ObjectType.House12 : defs_1.ObjectType.Chiron;
    var lastExtObject = (mode === "transits")
        ? defs_1.ObjectType.Chiron
        : (['solars', 'prog_natal'].includes(mode) && forDoubleMapWithOutNatal)
            ? defs_1.ObjectType.Lilith
            : defs_1.ObjectType.House12;
    var xModes = ['directions', 'prog_prog', 'prog_natal'];
    for (var obj = 0; obj <= objectLength; obj++) {
        if (obj === defs_1.ObjectType.Selena) {
            continue;
        }
        if ((0, astro_utils_1.isNotTransits)(mode) && obj === defs_1.ObjectType.Chiron) {
            continue;
        }
        var objInfo = obj >= defs_1.ObjectType.House1 ? {
            lon: houses[obj - defs_1.ObjectType.House1],
            speed: 0
        } : objects[obj];
        var objExt = (mode === 'prog_prog') ? obj + 1 : 0;
        var _loop_1 = function () {
            if ((0, astro_utils_1.isNotTransits)(mode) && objExt === defs_1.ObjectType.Chiron ||
                objExt === defs_1.ObjectType.Selena) {
                return "continue";
            }
            var extInfo = objExt >= defs_1.ObjectType.House1 ? {
                lon: housesExt[objExt - defs_1.ObjectType.House1],
                speed: mode === 'directions' ? objectsExt[0].speed : 0
            } : objectsExt[objExt];
            var bestType = -1;
            var bestDiff = 100;
            var bestOrbise = 0;
            for (var _i = 0, allAspects_3 = constants_1.allAspects; _i < allAspects_3.length; _i++) {
                var aspType = allAspects_3[_i];
                if (!(constants_1.majorAspects.includes(aspType) ||
                    xModes.includes(mode))
                    || ((forDoubleMapWithOutNatal || mode === 'prog_prog')
                        &&
                            (((aspType === defs_1.AspectType.Conjunction) && (obj === objExt))
                                ||
                                    ((aspType === defs_1.AspectType.Opposition)
                                        && (obj >= defs_1.ObjectType.House1 && objExt >= defs_1.ObjectType.House1))))) {
                    continue;
                }
                var orb = getPairOrbise(mode, obj, objExt, aspType);
                var asp = checkAspect(orb, objInfo.lon, extInfo.lon, aspType, opts);
                if (asp.exists &&
                    asp.diff < bestDiff &&
                    (constants_1.majorAspects.includes(aspType) ||
                        !constants_1.majorAspects.includes(bestType))) {
                    bestDiff = asp.diff;
                    bestType = aspType;
                    bestOrbise = orb;
                }
            }
            if (bestType !== -1) {
                var asp_1 = {
                    id: aspects.length,
                    type: bestType,
                    obj1: obj,
                    lon1: objInfo.lon,
                    obj2: objExt,
                    lon2: extInfo.lon,
                    orbise: bestOrbise,
                    realOrbise: bestDiff
                };
                if (mode !== 'solars') {
                    asp_1.diff = getAspectDiff(bestType, objInfo.lon, extInfo.lon, 0, extInfo.speed);
                }
                if (forDoubleMapWithOutNatal) {
                    var mirrorAspIndex = aspects.findIndex(function (aspect, idx) {
                        return aspect.type === asp_1.type
                            && aspect.obj1 < defs_1.ObjectType.House1 && aspect.obj2 < defs_1.ObjectType.House1
                            && asp_1.obj1 < defs_1.ObjectType.House1 && asp_1.obj2 < defs_1.ObjectType.House1
                            && (aspect.obj1 === asp_1.obj2 && aspect.obj2 === asp_1.obj1);
                    });
                    if (mirrorAspIndex !== -1) {
                        if (asp_1.obj2 > aspects[mirrorAspIndex].obj2) {
                            aspects[mirrorAspIndex] = __assign({}, asp_1);
                        }
                        else {
                            return "continue";
                        }
                    }
                    ;
                }
                aspects.push(asp_1);
            }
        };
        for (; objExt <= lastExtObject; objExt++) {
            _loop_1();
        }
    }
    return aspects;
}
exports.prognosticsAspects = prognosticsAspects;
function synastryTransitAspects(transitObjects, transitHouses, partnerObjects, partnerHouses, natalObjects, natalHouses, synastryAspects, opts, getPairOrbise, transitMode) {
    if (transitMode === void 0) { transitMode = 1; }
    var transitPartnerAspects = [];
    var transitNatalAspects = [];
    if (transitMode === 1) {
        transitNatalAspects = prognosticsAspects('transits', natalObjects, natalHouses, transitObjects, transitHouses, opts, getPairOrbise);
        transitPartnerAspects = prognosticsAspects('transits', partnerObjects, partnerHouses, transitObjects, transitHouses, opts, getPairOrbise);
    }
    else if (transitMode === 2) {
        transitPartnerAspects = [];
        transitNatalAspects = [];
        var _orbise_1 = 2;
        var conjuctionAspects = synastryAspects.filter(function (aspect) { return aspect.type === defs_1.AspectType.Conjunction; });
        var transitWithNatalHouses = houseAspects(transitObjects, natalHouses, 0, _orbise_1, opts).filter(function (aspect) { return aspect.type === defs_1.AspectType.Conjunction; });
        var transitWithPartnerHouses = houseAspects(transitObjects, partnerHouses, 0, _orbise_1).filter(function (aspect) { return aspect.type === defs_1.AspectType.Conjunction; });
        conjuctionAspects.forEach(function (conjuctionAspect, aspectId) {
            transitObjects.forEach(function (transitObject, transitObjectId) {
                var bestOrbise = 0;
                var bestDiff = 100;
                var aspectTransitWithObj1 = checkAspect(_orbise_1, conjuctionAspect.lon1, transitObject.lon, defs_1.AspectType.Conjunction, opts);
                var aspectTransitWithObj2 = checkAspect(_orbise_1, conjuctionAspect.lon2, transitObject.lon, defs_1.AspectType.Conjunction, opts);
                if (aspectTransitWithObj1.exists && aspectTransitWithObj1.diff < bestDiff) {
                    bestDiff = aspectTransitWithObj1.diff;
                }
                if (aspectTransitWithObj2.exists && aspectTransitWithObj2.diff < bestDiff) {
                    bestDiff = aspectTransitWithObj2.diff;
                    bestOrbise;
                }
                if (aspectTransitWithObj1.exists || aspectTransitWithObj2.exists) {
                    var _asp = {
                        id: transitNatalAspects.length + transitPartnerAspects.length,
                        type: defs_1.AspectType.Conjunction,
                        obj1: conjuctionAspect.obj1,
                        lon1: conjuctionAspect.lon1,
                        obj2: conjuctionAspect.obj2,
                        lon2: conjuctionAspect.lon2,
                        obj3: transitObjectId,
                        lon3: transitObject.lon,
                        orbise: _orbise_1,
                        realOrbise: bestDiff,
                        diff: bestDiff
                    };
                    if (aspectTransitWithObj1.exists) {
                        transitNatalAspects.push(_asp);
                    }
                    else if (aspectTransitWithObj2.exists) {
                        transitPartnerAspects.push(_asp);
                    }
                }
            });
        });
        transitNatalAspects = __spreadArray(__spreadArray([], transitNatalAspects, true), (transitWithNatalHouses).map(function (aspect) {
            return __assign(__assign({}, aspect), { obj1: aspect.obj2, lon1: aspect.lon2, obj2: -1, lon2: -1, obj3: aspect.obj1, lon3: aspect.lon1 });
        }), true);
        transitPartnerAspects = __spreadArray(__spreadArray([], transitPartnerAspects, true), (transitWithPartnerHouses).map(function (aspect) {
            return __assign(__assign({}, aspect), { obj1: -1, lon1: -1, obj3: aspect.obj1, lon3: aspect.lon1 });
        }), true);
    }
    transitPartnerAspects = transitPartnerAspects.map(function (aspect, idx) {
        aspect.id = synastryAspects.length + idx;
        return aspect;
    });
    transitNatalAspects = transitNatalAspects.map(function (aspect, idx) {
        aspect.id = (synastryAspects.length + transitPartnerAspects.length) + idx;
        return aspect;
    });
    return {
        transitPartnerAspects: transitPartnerAspects,
        transitNatalAspects: transitNatalAspects
    };
}
exports.synastryTransitAspects = synastryTransitAspects;
function houseAspects(objects, houses, startId, orbise, opts, sendRealOrb) {
    if (orbise === void 0) { orbise = 0; }
    if (opts === void 0) { opts = {}; }
    if (sendRealOrb === void 0) { sendRealOrb = false; }
    var aspects = [];
    for (var obj = defs_1.ObjectType.Sun; obj <= defs_1.ObjectType.Pluto; obj++) {
        for (var h = 0; h < 12; h++) {
            var bestType = -1;
            var bestDiff = 100;
            for (var _i = 0, majorAspects_1 = constants_1.majorAspects; _i < majorAspects_1.length; _i++) {
                var aspType = majorAspects_1[_i];
                var asp = checkAspect(orbise, objects[obj].lon, houses[h], aspType, opts);
                if (asp.exists && asp.diff < bestDiff) {
                    bestDiff = asp.diff;
                    bestType = aspType;
                }
            }
            if (bestType !== -1) {
                aspects.push({
                    id: startId++,
                    type: bestType,
                    obj1: obj,
                    lon1: objects[obj].lon,
                    obj2: h + defs_1.ObjectType.House1,
                    lon2: houses[h],
                    orbise: orbise,
                    realOrbise: sendRealOrb ? bestDiff : orbise
                });
            }
        }
    }
    return aspects;
}
exports.houseAspects = houseAspects;
function pairObject(obj) {
    if (obj < defs_1.ObjectType.House1) {
        return -1;
    }
    if (obj === defs_1.ObjectType.House10) {
        return defs_1.ObjectType.House4;
    }
    return obj + 6;
}
function getAspectsPairs(aspects, circle, pairAspects) {
    aspects
        .forEach(function (a, ai) {
        if (a.obj1 >= defs_1.ObjectType.House1 || a.obj2 >= defs_1.ObjectType.House1) {
            aspects
                .forEach(function (b, bi) {
                if ((b.obj1 >= defs_1.ObjectType.House1 || b.obj2 >= defs_1.ObjectType.House1) &&
                    (b.obj1 === a.obj1 && pairObject(a.obj2) === b.obj2 ||
                        b.obj2 === a.obj2 && pairObject(a.obj1) === b.obj1)) {
                    if (!pairAspects[circle]) {
                        pairAspects[circle] = {};
                    }
                    pairAspects[circle][ai] = bi;
                    pairAspects[circle][bi] = ai;
                }
            });
        }
    });
}
exports.getAspectsPairs = getAspectsPairs;
